const PATH = {
  SERVICE_NAME: {
    ORDER: "order",
    AUTH: "auth",
    LOYALTY: "loyalty",
    WALLET: "wallet",
    UTILS: "utils",
  },
  RELATIVE_PATH: {
    GET: {
      CARD_BALANCE: "/my_card_balance/list/",
      EXCHANGE_PLAN: "/my_exchange_plan/",
      MY_CARDS_LIST: "/my_cards/list_create/",
      WALLET_SIGNATURE: "wallet/get_signature/",
      BANK_CREDIT_CHARGE: "/my_bank_credit_charge/list/",
      WALLET_GET_QR_CODE: "wallet/invoice/get_qr_code/",
      WALLET_INVOICE_BUYER_RETRIEVE: "/invoice/buyer/retrieve/",
      STORE_LOYALTY_PLAN_LIST_CREATE: "/store_loyalty_plan/list_create",
      JET_VAM_SIGNUP: "/api/v1/jetvam_signup_status/",
      NAVBAR_LIST: "config/navbar/List/",
      MEDIA_SLIDER_LIST: "config/Media/List/",
      WALLET_RECEIPT_RETRIEVE: "/api/v1/wallet_receipt/retrieve/",
      PROVINCE_LIST: "config/province/list_create/",
      INVOICE_STORE_LIST: "/api/v1/invoice_store/list/",
      LOAN_PROVIDERS: "loyalty/api/v1/loan_providers/list/",
      USER_WALLET_TRANSACTION_LINE_LIST:
        "/api/user_wallet_transaction_line/list/",
      SELF_LOAN_REQUEST_RETRIEVE_ID: "/self_loan_request_retrieve/",
      USER_LOAN_CASE: "/User_loan_case_get/",
      CITY_LIST: "config/city/list_create/",
      BLU_NEED_CORRECTION_FIELDS: "/blu_need_correction_fields/",
      WALLET_TRANSACTION_USER_BALANCE: "wallet/transaction/user_balance/",
      USER_HAS_SUBSCRIPTION: "/user_has_subscription/",
      BLU_GET_CONTRACT_FILE: "/blu_get_contract_file/",
      BLU_GET_CONTRACT_OTP: "/blu_get_contract_otp/",
      NESTED_LOAN_REQUEST: "/nested_loan_request/",
      STORE_ALL_MEDIA: "/store_all_media/",
      REFERRED_USER: "v1/client/loyalty/referred_user/",
      REFERRED_USER_LOAN_STATUS: "v1/client/loyalty/referred_user/loan_status/",
    },
    POST: {
      PHONE_NUMBER_OTP_REQ: "/otp/request/",
      OTP_VERIFY: "/otp/verify/",
      USER_INFO_UPDATE: "/user_info/update/",
      INVOICE_CODE_REQUEST: "/invoice/code_request/",
      INVOICE_CODE_VALIDATE: "/invoice/code_validate/",
      CREATE_PAYMENT: "payment/v1/create_payment/",
      BLU_UPLOAD_FILE: "/blu_upload_file/",
      BLU_CREATE_PAYMENT: "payment/v2/create_payment/",
      LOAN_REQUEST_CREATE: "/loan_request_create/",
      BLU_POST_CONTRACT_OTP: "/blu_post_contract_otp/",
      STORE_OTP_FOR_CLIENT_REQUEST: "/store_otp_for_client/request/",
      STORE_OTP_FOR_CLIENT_VERIFY: "/store_otp_for_client/verify/",
    },
    MULTI: {
      STORE_CATEGORY: "/store_category/list_create/",
      STORE_LOYALTY_PLAN: "/store_loyalty_plan/list_create/",
      STORE_LIST: "/store/list_create/",
      STORE_CATEGORY_EDIT: "/store_category/edits/",
      STORE_PLAN: "/store_loyalty_plan/edits/",
      STORE_CONDITION: "/store_condition/list_create/",
      STORE_SETTING: "auth/me/",
      STORE_LIKE: "/toggle_my_favorite/",
      REFERRAL_CODE: "/referred_code/list_create/",
      CART_LIST: "/my_cards/list_create/",
      BANK_INFO: "/bank_info/list_create/",
      TRANSACTION_LIST: "/outer_transaction/list_create/",
      SELLER_LIST_CREATE: "/invoice/seller/list_create/",
      STORE_MEDIA_LIST: "/store_media/list_create/",
      TAG_MANAGER_LIST: "config/tag_manager/list_create/",
      MY_STORE_LIST: "/my_stores/list_create/",
      STORE_GROUP_LIST_CREATE: "/store_group/list_create/",
      CONVERSATION_SEEN: "/api/v1/conversation/seen/",
      CONVERSATION_LIST_CREATE: "/api/v1/conversation/list_create/",
      CONVERSATION_MESSAGE_LIST: "/api/v1/conversation_message/list_create/",
      PRE_LOAN_REGISTER: "/pre_loan_register/",
      NESTED_LOAN_PAYMENT_PLAN: "/nested_loan_payment_plan/",
      LOAN_SUBSCRIPTION_PRICE: "loyalty/subscription_price/",
      SELF_LOAN_REQUEST: "loyalty/self_loan_request/",
      USER_LOAN_CASE_UPDATE: "/User_loan_case_update/",
      LOAN_CASE_DOCUMENT_UPLOAD: "/loan_case_document_upload/",
      BLU_IRANIAN_CREDIT_QUERY_OTP: "/blu_iranian_credit_query_otp/",
      BLU_LOAN_CHEQUE_GUARANTEE: "/blu_loan_cheque_guarantee/",
      BLU_CREATE_LOAN_CASE: "/blu_create_loan_case/",
      BLU_PRE_CREATE_LOAN_CASE: "/blu_pre_create_loan_case/",
      GB_BACK_UPLOAD_FILE: "/gback_upload_file/",
      STORE_UPDATE_IMAGE: "/store_update_image/",
      STORE_MEDIA_CREATE: "/store_media_create/",
      STORE_MEDIA_UPDATE: "/store_media_update/",
      STORE_DETAIL: "/store_detail/",
      BLU_CHEQUE_POSTING: "/blu_cheque_posting/",
    },
  },
};

module.exports = PATH;
